import Api from '../Helper/Api';

class ElectionAction {



    statewise(data) {

        let resp = Api.getApi(data, 'get-election-data-for-state', 'GET');

        return resp
    }
    nationalwise(data) {
        let resp = Api.getApi(data, 'election-data-national', 'GET');

        return resp

    }


}

export default ElectionAction.prototype;